import type { ComponentProps } from 'react';
import { cn } from './cn';
import { focusRing } from './focus';

/**
 * A pin over the board that opens what it marks (a comment thread): named by `label`, its count inside, the accent
 * colours, muted once `resolved`; `expanded` while its thread is open. The caller places it (`style.transform`).
 */
export function PinButton({
  label,
  count,
  expanded,
  resolved,
  className,
  ...rest
}: Omit<ComponentProps<'button'>, 'children'> & { label: string; count: number; expanded?: boolean; resolved?: boolean }) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={expanded}
      className={cn(
        // 28 px drawn (its corner points at the spot); under a finger, an invisible 8 px margin makes the target 44 px.
        'relative flex h-7 min-w-7 items-center justify-center rounded-full rounded-bl-none border-2 border-bg px-1.5 font-sans text-xs font-bold shadow-md pointer-coarse:before:absolute pointer-coarse:before:-inset-2 pointer-coarse:before:content-[""]',
        resolved ? 'bg-fg-muted text-surface' : 'bg-accent text-accent-fg',
        expanded && 'ring-2 ring-accent ring-offset-1',
        focusRing,
        className,
      )}
      {...rest}
    >
      {count}
    </button>
  );
}
